import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'countryCodeToName' })
export class CountryCodeToNamePipe implements PipeTransform {
    transform(countryCode: string): string {
        if (!countryCode) {
            return '';
        }

        const normalizedName = countryCode.trim();

        switch (normalizedName.toLowerCase()) {
            case 'ca':
                return 'Canada';
            case 'mx':
                return 'Mexico';
            case 'us':
                return 'United States';
            default:
                return normalizedName;
        }
    }
}
